import {
  Input as InputAntd,
  InputNumber as InputNumberAntd,
  InputNumberProps,
  InputProps,
} from 'antd';
import './index.style.less';

export declare type InputColors = 'white' | 'inherit';
interface IInputProps extends InputProps {
  background?: InputColors;
}

export const Input = (props: IInputProps) => {
  return (
    <InputAntd
      {...props}
      className={`fullContent input-basic ${props.background ? `${props.background}` : ''} ${props.className}`}
    />
  );
};

export const InputPassword = (props: InputProps) => {
  return (
    <InputAntd.Password
      {...props}
      className={`fullContent input-password-basic ${props.className}`}
    />
  );
};

export const InputNumber = (props: InputNumberProps) => {
  return (
    <InputNumberAntd
      {...props}
      className={`fullContent input-number-basic ${props.className}`}
    />
  );
};
